import { connect } from "react-redux";
import EmailVerification from "./EmailVerification";
import { verifyCode, resendVerificationCode, resetVerifyCode } from "../../VerificationCode/verificationCodeActions";

const mapStateToProps = (state) => ({
  verificationCode: state.verificationCode,
  userData: state.verificationCode?.userData,
  isLoading: state.verificationCode?.isLoading || false,
});

const mapDispatchToProps = {
  verifyCode,
  resendVerificationCode,
  resetVerifyCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);